import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import "./index.less";
import { Button, Input, Spin } from "@arco-design/web-react";
import { IconLeft, IconSearch } from "@arco-design/web-react/icon";
import { observer } from "mobx-react-lite";
import AgentStore from "@/stores/agentLogin";
import { getAgentList } from "@/services/login";
import Empty from "../Empty";
import dayjs from "dayjs";
import ApiScrollList from "../ApiScrollList";
function isToday(timestamp) {
  // 秒级时间戳转毫秒
  if (!timestamp) return false;
  if (timestamp.toString().length === 10) {
    timestamp = timestamp * 1000;
  }

  const target = dayjs(timestamp);

  const startOfDay = dayjs().startOf("day"); // 今天 0 点
  const endOfDay = dayjs().endOf("day"); // 今天 23:59:59.999

  return target.isAfter(startOfDay) && target.isBefore(endOfDay);
}
function maskPhone(phone) {
  if (!phone) return "";
  if (typeof phone !== "string") {
    phone = String(phone);
  }
  // 简单校验手机号长度是否为11位
  if (phone.length !== 11) {
    return phone; // 不符合手机号长度，直接返回原值
  }
  return phone.substring(0, 3) + "****" + phone.substring(7);
}
function AgentList(props) {
  const { handleChange, clear, type = 1, renderProps } = props;
  const [countMap, setCountMap] = useState({
    all: 0,
    login: "-",
    notLogin: "-",
  });
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeItem, setActiveItem] = useState<any>({});
  const [changeType, setChangeType] = useState<number>(1);
  const handleGetAgentList = useCallback(async (params = {} as any) => {
    setActiveItem({});
    // setLoading(true);
    const res = await getAgentList({
      ...params,
    });
    console.log("xxxxxxxxxxxxxxxxxxxxxxxxx", res);
    if (params.type === 1) {
      setCountMap((prev) => ({
        ...prev,
        all: res.data.total ?? 0,
      }));
    } else if (params.type === 2) {
      setCountMap((prev) => ({
        ...prev,
        login: res.data.total ?? 0,
      }));
    } else if (params.type === 3) {
      setCountMap((prev) => ({
        ...prev,
        notLogin: res.data.total ?? 0,
      }));
    }

    // setLoading(false);
    // if (res.code === 0) {
    //   setList(
    //     res.data?.items?.map((v) => ({
    //       ...v,
    //       isLogin: isToday(v.today_login),
    //     })) || []
    //   );
    // }
    setTotal(res.data.total);

    return {
      data:
        res.data?.items?.map((v) => ({
          ...v,
          isLogin: isToday(v.today_login),
        })) || [],
      total: res.data.total,
    };
  }, []);

  const params = useMemo(() => {
    return {
      keyword,
      type: changeType,
      page_size: 20,
    };
  }, [keyword, changeType]);

  // useEffect(() => {
  //   if (AgentStore.agent_info && Object.keys(AgentStore.agent_info).length) {
  //     if (!keyword) {
  //       handleGetAgentList();
  //     }
  //   }
  // }, [keyword]);
  useEffect(() => {
    handleChange?.(activeItem);
    renderProps?.({
      getList: handleGetAgentList,
    });
  }, [activeItem]);

  return (
    <div
      className="agent-list-root"
      style={{
        height: type === 1 ? 400 : 460,
      }}
    >
      {type === 1 ? (
        <p className="agent-list-title">
          {clear ? (
            <span>
              <IconLeft
                fontSize={18}
                onClick={() => {
                  setActiveItem({});
                  // setList([]);
                  setKeyword("");
                  AgentStore.setLoginInfo({});
                }}
              />
            </span>
          ) : (
            <span></span>
          )}
          <span>选择你要登录的账号:</span>
          <span>&emsp;</span>
        </p>
      ) : (
        <></>
      )}

      <Input
        className="agent-list-input"
        placeholder="请输入客户名称"
        style={{
          marginTop: type === 1 ? 15 : 0,
        }}
        prefix={<IconSearch />}
        value={keyword}
        onChange={(e) => {
          setKeyword(e);
        }}
        // onKeyDown={(e) => {
        //   if (e.keyCode === 13) {
        //     handleGetAgentList();
        //   }
        // }}
      />

      {type === 2 ? (
        <div className="agent-list-change">
          <Button
            onClick={() => setChangeType(1)}
            className={`${changeType === 1 ? "active" : ""}`}
          >
            全部 ({countMap.all})
          </Button>
          <Button
            onClick={() => setChangeType(2)}
            className={`${changeType === 2 ? "active" : ""}`}
          >
            今日已登录 ({countMap.login})
          </Button>
          <Button
            onClick={() => setChangeType(3)}
            className={`${changeType === 3 ? "active" : ""}`}
          >
            今日未登录 ({countMap.notLogin})
          </Button>
        </div>
      ) : (
        <></>
      )}
      {type === 2 ? (
        <p className="agent-list-title" style={{ marginBottom: 8 }}>
          <span></span>
          <span>选择你要切换的账号:</span>
          <span></span>
        </p>
      ) : (
        <></>
      )}

      <ApiScrollList
        api={handleGetAgentList}
        params={params}
        height={type === 1 ? "278px" : "290px"}
        renderList={(list) => {
          console.log("xxxxxxxxxxxxxxxxxxxxxxxxx", list);
          return (
            <div
              className="agent-list-content"
              // style={{
              //   height: type === 1 ? 278 : 290,
              // }}
            >
              {list.length > 0 &&
                list.map((item, index) => (
                  <div
                    className="agent-item"
                    key={index}
                    style={
                      activeItem?.id === item.id
                        ? {
                            background:
                              "linear-gradient(-270deg, #165DFF 0%, #BE7BFF 100%)",
                            color: "#FFFFFF",
                          }
                        : {}
                    }
                    onClick={() => {
                      setActiveItem(item);
                    }}
                  >
                    {type === 1 ? (
                      item.name
                    ) : (
                      <div className="agent-item-change">
                        <div
                          style={
                            activeItem?.id === item.id
                              ? {
                                  color: "white",
                                  background:
                                    "linear-gradient( 140deg, rgba(255,255,255,0.5) 0%, rgba(222,190,255,0.5) 100%)",
                                }
                              : {}
                          }
                          className="agent-item-avatar"
                        >
                          {item.name.slice(0, 1)}
                        </div>
                        <div>
                          <p
                            style={
                              activeItem?.id === item.id
                                ? {
                                    color: "#FFFFFF",
                                  }
                                : {}
                            }
                          >
                            {item.name}
                          </p>
                          <p
                            style={
                              activeItem?.id === item.id
                                ? {
                                    color: "#FFFFFF",
                                  }
                                : {}
                            }
                          >
                            {maskPhone(item.phone)}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
            </div>
          );
        }}
        onLoaded={setList}
      ></ApiScrollList>
    </div>
  );
}

export default memo(AgentList);
